import resolveComponent from '../resolveComponent';

/**
 * @example `/${appid}${appRankingManagePrefix}`
 * @example `/:appId${appRankingManagePrefix}`
 *  */
export const appRankingManagePrefix = '/ranking-manage';
export const appRankingManagePrefixName = '榜单管理';

/**
 * @example `/${appid}${appRankingManagePrefix_account}`
 * @example `/:appId${appRankingManagePrefix_account}`
 *  */
export const appRankingManagePrefix_account = `${appRankingManagePrefix}/account`;
export const appRankingManagePrefix_accountName = '帐号榜单';

/**
 * @example `/${appid}${appRankingManagePrefix_school}`
 * @example `/:appId${appRankingManagePrefix_school}`
 *  */
 export const appRankingManagePrefix_school = `${appRankingManagePrefix}/school`;
 export const appRankingManagePrefix_schoolName = '学校榜单';
 
const ImageTextManageRouteConfig = [
  {
    path: `/:appId?${appRankingManagePrefix}`,
    label: appRankingManagePrefixName,
    exact: false,
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `/:appId?${appRankingManagePrefix_account}`,
        exact: true,
        label: appRankingManagePrefix_accountName,
        component: resolveComponent(() => import('@src/pages/app/rankingManage/account')),
      },
      {
        path: `/:appId?${appRankingManagePrefix_school}`,
        exact: true,
        label: appRankingManagePrefix_schoolName,
        component: resolveComponent(() => import('@src/pages/app/rankingManage/school')),
      },
    ],
  },
];

export default ImageTextManageRouteConfig;
